import Vue from 'vue';
import 'flag-icon-css/css/flag-icon.css';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import WebConn from './plugins/webconn';
import Storage from './plugins/storage';

require('@/assets/css/beerplanet.css');

Vue.config.productionTip = false;

const rootUrl = 'https://beerplanet.net/wp-admin/admin-ajax.php';

Vue.use(WebConn, {
  rootUrl,
});

Vue.use(Storage);

const mixin = {
  methods: {
    afterLogin(result) {
      if (result.Token) {
        this.$storage.write('token', result.Token);
        this.$store.state.token = result.Token;
      }

      // also set token for current webconn
      this.$webConn.setToken(this.$store.state.token);
      this.$store.state.username = result.Username;
      this.$store.state.nickname = result.Nickname;
      this.$store.state.email = result.Email;
      this.$store.state.avatar = result.Avatar;
      this.$store.state.collections = result.Collections;
      this.$store.state.loggedIn = true;
      // emmit login event
      this.$root.$emit('loggedIn');
      // catch to hide bug in vue router that gives error when already on page
      this.$router.push('/').catch(() => {});
      // console.log(this.$store.state.collections);
    },
  },
  deviceReady(result) {
    console.log('Device ready!');
  },
};

const vueApp = new Vue({
  router,
  store,
  vuetify,
  WebConn,
  mixins: [mixin],
  render: (h) => h(App),
  created() {
    const Token = this.$storage.read('token');
    this.$store.state.token = Token;

    if (process.env.CORDOVA_PLATFORM) {
      console.log('Cordova detected');
      this.$store.state.cordova = true;
    }
  },
  methods: {
    onDeviceReady() {
      this.$root.$emit('deviceReady');
    },
  },
}).$mount('#app');


// cordova events
document.addEventListener('deviceready', vueApp.onDeviceReady);
